import { Trans, useTranslation } from 'react-i18next'

import { Alert, Text } from '@reveni-io/reveni-ui'

const ConfigurationRefundsInfo = () => {
  const { t } = useTranslation()

  return (
    <Alert type="info">
      <Trans i18nKey="configurationRefundsInfo">
        Si por la configuración elegida no hubiera disponible ningún método de reembolso para una solicitud, en el
        portal se mostrará por defecto{' '}
        <Text type="bodyMBold" tag="span">
          {t('Método de pago original')}.
        </Text>
      </Trans>
    </Alert>
  )
}

export default ConfigurationRefundsInfo
